<template>
  <div class="code-item">
    <el-input :maxlength="6" v-model="code" placeholder="请输入验证码" @input="onInput" @blur="onBlur"></el-input>
    <el-button type="primary" class="btn-code" :disabled="isDisabled" @click="onGetSmsCode">{{ text }}</el-button>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import baseApi from '@/dss-common/api/base';
import emitter from 'element-ui/lib/mixins/emitter.js';

export default {
  mixins: [emitter],
  props: {
    phone: {
      type: String,
      default: '',
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    reqMethod: {
      tpye: String,
      default: 'smsCode',
    },
  },
  data() {
    return {
      text: '获取验证码',
      isDisabled: false,
    };
  },
  computed: {
    code: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    value(val) {
      // this.dispatch('ElFormItem', 'el.form.blur', [val]);
    },
  },
  beforeDestroy() {
    if (this.taskId) {
      clearInterval(this.taskId);
    }
  },
  methods: {
    inputSmsCode() {
      if (this.taskId) {
        clearInterval(this.taskId);
        this.taskId = null;
        this.isDisabled = false;
      }
      let time = 60;
      this.text = `${time}秒`;
      this.isDisabled = true;
      this.taskId = setInterval(() => {
        time--;
        if (time <= 0) {
          clearInterval(this.taskId);
          this.isDisabled = false;
          this.taskId = null;
          this.text = '获取验证码';
          return;
        }
        this.text = `${time}秒`;
      }, 1000);
    },
    onGetSmsCode() {
      if (!this.phone) {
        Message({
          showClose: true,
          type: 'error',
          duration: 3000,
          message: '请输入您的手机号',
        });
        return;
      }
      const params = {
        phone: this.phone,
        ...this.verifyData,
      };
      baseApi[this.reqMethod](params).done(() => {
        this.inputSmsCode();
      });
    },
    onInput(val) {
      this.dispatch('ElFormItem', 'el.form.change', [val]);
    },
    onBlur() {
      this.dispatch('ElFormItem', 'el.form.blur', [this.code]);
    },
  },
};
</script>

<style scope>
.code-item {
  padding-right: 130px;
}

.btn-code {
  position: absolute;
  top: 0;
  right: 0;
  width: 108px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  color: #333333;
}
/* .btn-code:hover {
    background: #fff;
    color: #333333;
    border: 1px solid #d9d9d9;
  } */
.el-button--primary.is-disabled {
  background: #fff;
  color: #333333;
  border: 1px solid #d9d9d9;
}
</style>
